export enum Order {
    asc = "asc",
    desc = "desc",
}

export type SortOrder<T> = { orderBy: T; order: Order }
